import { render, staticRenderFns } from "./BaseProfile.vue?vue&type=template&id=022c963a&scoped=true&"
import script from "./BaseProfile.vue?vue&type=script&lang=js&"
export * from "./BaseProfile.vue?vue&type=script&lang=js&"
import style0 from "./BaseProfile.vue?vue&type=style&index=0&id=022c963a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c963a",
  null
  
)

export default component.exports